import { removeHtmlTag } from '@exam-management/common/utils';
import { z } from 'zod';

export const SearchSelectionSchema = z.object({
  value: z.string(),
  label: z.string(),
});

export const NullishSearchSelectionSchema = SearchSelectionSchema.nullish();

export const ConvertEmptyStringToUndefinedSchema = z
  .string()
  .nullish()
  .transform((value) => {
    if (value === '') return undefined;
    return value;
  });

export const validateWithoutPTag = (message: string) => {
  return z.string().refine(
    (value) => {
      const details = removeHtmlTag(value, {
        customTag: 'p',
      }).trim();
      return details.length >= 1;
    },
    {
      message,
    },
  );
};
